export default __webpack_public_path__ + "static/media/XpressCarLoanLogo.84ba0a91.png";